import EditorJS from '@editorjs/editorjs';
import Header from '@editorjs/header';
import Raw from '@editorjs/raw';
import List from '@editorjs/list';
import Embed from '@editorjs/embed';
import Quote from '@editorjs/quote';
import InlineCode from '@editorjs/inline-code';
import Delimiter from '@editorjs/delimiter';
import CodeTool from '@editorjs/code';
import Image from '../admin/editor/image';
import TextImage from '../admin/editor/text-image';
import Columns from '../admin/editor/columns';
import FancyList from '../admin/editor/fancy-list';
import Redactor from '../admin/editor/redactor';
import Gallery from '../admin/editor/gallery';
import Button from '../admin/editor/button';
import { Highlight } from '../admin/editor/text-highlight/textHighlight';
import { Strikethrough } from '../admin/editor/strikethrough/strikethrough';
import { Underline } from '../admin/editor/underline/underline';

export default function setupEditor({ holder, data, onChange }) {
  return new EditorJS({
    holder,
    data,
    placeholder: 'Start writing or press the Tab key to select a block 🕺',
    onChange,
    tools: {
      header: Header,
      list: { class: List, inlineToolbar: true },
      image: Image,
      'text-image': { class: TextImage, inlineToolbar: true },
      columns: { class: Columns, inlineToolbar: true },
      'fancy-list': { class: FancyList, inlineToolbar: true },
      quote: Quote,
      delimiter: Delimiter,
      code: CodeTool,
      redactor: Redactor,
      raw: Raw,
      gallery: { class: Gallery, inlineToolbar: true },
      button: Button,
      Highlight,
      Strikethrough,
      InlineCode,
      Underline,
      embed: Embed
    }
  });
}
